function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "locked-markets",
  transform: "translate(-307.93 -82.799)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_542",
  "data-name": "Grupo 542"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_859",
  "data-name": "Caminho 859",
  d: "M310.105,89.576h-.829c0-.015,0-1.485.1-2.8a4.257,4.257,0,0,1,4.279-3.974,4.155,4.155,0,0,1,4.281,4v2.59h-.829V86.8a3.327,3.327,0,0,0-3.452-3.176,3.435,3.435,0,0,0-3.452,3.206C310.106,88.121,310.105,89.561,310.105,89.576Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_543",
  "data-name": "Grupo 543"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_860",
  "data-name": "Caminho 860",
  d: "M318.244,98.8h-9.278a1.038,1.038,0,0,1-1.036-1.036V90.32a1.038,1.038,0,0,1,1.036-1.037h9.278a1.039,1.039,0,0,1,1.037,1.037v7.443A1.038,1.038,0,0,1,318.244,98.8Zm-9.278-8.686a.207.207,0,0,0-.207.207v7.443a.207.207,0,0,0,.207.207h9.278a.207.207,0,0,0,.207-.207V90.32a.207.207,0,0,0-.207-.207Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_544",
  "data-name": "Grupo 544"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_861",
  "data-name": "Caminho 861",
  d: "M313.575,95.741a1.883,1.883,0,1,1,1.882-1.883A1.885,1.885,0,0,1,313.575,95.741Zm0-2.937a1.054,1.054,0,1,0,1.053,1.054A1.055,1.055,0,0,0,313.575,92.8Z"
})));

function SvgPadlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.351,
    height: 16,
    viewBox: "0 0 11.351 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.8a29dc51.svg";
export { ForwardRef as ReactComponent };